import { RushGlide } from './_rush-glide';

export class AppointmentHubStorySlider extends DrupalBehavior {
  onContent(context) {
    const mobileMediaQuery = window.matchMedia('(max-width: 991px)');
    if (mobileMediaQuery.matches) {
      this.setUpMobileState(context);
    }
  }

  addGlideClassesForMobile(slider) {
    const articles = $('.article.article--teaser', slider);

    articles.each((index, article) => {
      $(article).addClass('glide__slide');
    });
  }

  setUpMobileState(context) {
    const sliders = $(
      '.service--related-stories--items.glide',
      context
    ).toArray();

    if (sliders && sliders.length) {
      sliders.forEach((slider) => {
        this.addGlideClassesForMobile(slider);
        const rushGlide = new RushGlide();
        rushGlide.setUpGlide(slider, {
          peakPixels: 75,
          gap: 30,
        });
      });
    }
  }
}

DrupalBehavior.register(
  'rush_theme.components',
  'appointment_hub_story_slider',
  AppointmentHubStorySlider
);
